import Http from '@/utils/http/index'
import store from '@/store/index'

export const create = (payload) => Http.post('/company/subscription', payload)
    .then((response) => {
        store.dispatch('setTenant', response.data)
    })

export const update = (payload) => Http.put('/company/subscription', payload)
    .then((response) => {
        store.dispatch('setTenant', response.data)
    })

export const cancel = (id) => Http.delete(`/company/subscription`)

export const get = () => Http.get(`/company/subscription`)

export const getInvoices = () => Http.get(`/company/invoices`)

export const getCreditCard = () => Http.get(`/company/credit-card`)

export const addCreditCard = (payload) => Http.post(`/company/credit-card`, payload)



// WEBPACK FOOTER //
// ./src/services/subscriptions.js